import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Table, Tag, Tooltip, Space } from "antd";
import { useMemo, useState } from "react";
import EditTechCard from "src/features/Modal/ui/EditTechCard";
import TechCardDetailModal from "src/features/Modal/ui/TechCardDetailModal";



const CARD_MODE_CONFIG = {
  reference: { color: "blue",    text: "Справочный"  },
  semi_auto: { color: "orange",  text: "Полуавтомат" },
  auto:      { color: "green",   text: "Автомат"     },
};

const STATUS_CONFIG = {
  active:   { color: "green",   text: "Активна" },
  canceled: { color: "orange",  text: "Отменена" },
  deleted:  { color: "red",     text: "Удалена" },
};



export default function TechCards({ handleRemove, handleSave, dataSource, token }) {
  const [detailRecord, setDetailRecord] = useState(null);

  const columns = useMemo(() => [
    
    {
      title:     "Название",
      dataIndex: "name",
      key:       "name",
      sorter:    (a, b) => a.name.localeCompare(b.name),
      render:    (text, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{text}</div>
          {record.description && (
            <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
              {record.description.slice(0, 60)}
              {record.description.length > 60 ? "…" : ""}
            </div>
          )}
        </div>
      ),
    },

    
    {
      title:     "Режим",
      dataIndex: "card_mode",
      key:       "card_mode",
      width:     130,
      filters: Object.entries(CARD_MODE_CONFIG).map(([v, c]) => ({
        text: c.text, value: v,
      })),
      onFilter: (val, row) => row.card_mode === val,
      render:   (mode) => {
        const cfg = CARD_MODE_CONFIG[mode] || { color: "default", text: mode || "—" };
        return <Tag color={cfg.color}>{cfg.text}</Tag>;
      },
    },

    
    {
      title:     "Статус",
      dataIndex: "status",
      key:       "status",
      width:     110,
      render:    (status) => {
        const cfg = STATUS_CONFIG[status] || { color: "default", text: status };
        return <Tag color={cfg.color}>{cfg.text}</Tag>;
      },
    },

    
    {
      title:     "Компоненты",
      dataIndex: "items_count",
      key:       "items_count",
      width:     120,
      align:     "center",
      render:    (_, record) => {
        const cnt = record.items ? record.items.length : (record.items_count || 0);
        return <Tag>{cnt} поз.</Tag>;
      },
    },

    
    {
      title:     "Выход",
      dataIndex: "output_items_count",
      key:       "output_items_count",
      width:     100,
      align:     "center",
      render:    (_, record) => {
        const cnt = record.output_items
          ? record.output_items.length
          : (record.output_items_count || 0);
        return cnt > 0
          ? <Tag color="green">{cnt} поз.</Tag>
          : <Tag color="default">—</Tag>;
      },
    },

    
    {
      title:  "Склады",
      key:    "warehouses",
      width:  180,
      render: (_, record) => {
        const mode = record.card_mode;
        if (mode === "reference") return <span style={{ color: "#ccc" }}>—</span>;
        return (
          <Space direction="vertical" size={2}>
            {record.warehouse_from_id && (
              <Tooltip title="Склад сырья">
                <Tag color="red" style={{ fontSize: 11 }}>
                  Сырьё #{record.warehouse_from_id}
                </Tag>
              </Tooltip>
            )}
            {record.warehouse_to_id && (
              <Tooltip title="Склад продукта">
                <Tag color="green" style={{ fontSize: 11 }}>
                  Продукт #{record.warehouse_to_id}
                </Tag>
              </Tooltip>
            )}
          </Space>
        );
      },
    },

    
    {
      title:     "Создана",
      dataIndex: "created_at",
      key:       "created_at",
      width:     150,
      sorter:    (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render:    (dt) => dt
        ? new Date(dt).toLocaleString("ru-RU", {
            day:    "2-digit",
            month:  "2-digit",
            year:   "2-digit",
            hour:   "2-digit",
            minute: "2-digit",
          })
        : "—",
    },

    
    {
      title:  "Действия",
      key:    "action",
      fixed:  "right",
      width:  130,
      align:  "center",
      render: (_, record) => (
        <Space size={4}>
          <Tooltip title="Просмотр">
            <Button
              size="medium"
              icon={<EyeOutlined />}
              onClick={() => setDetailRecord(record)}
            />
          </Tooltip>

          <EditTechCard
            record={record}
            handleSave={handleSave}
            token={token}
          />

          <Popconfirm
            title="Удалить тех. карту?"
            description="Это действие нельзя отменить."
            onConfirm={() => handleRemove(record.id)}
            okText="Да"
            cancelText="Нет"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Удалить">
              <Button size="medium" icon={<DeleteOutlined />} danger />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ], [handleRemove, handleSave, token]);

  return (
    <>
      <Table
        columns={columns}
        rowKey={(r) => r.id}
        dataSource={dataSource}
        bordered
        size="small"
        scroll={{ x: 1100 }}
        rowClassName={(record) =>
          record.status === "deleted" ? "disabled-row" : ""
        }
        pagination={{
          pageSize:        20,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal:       (total, range) =>
            `${range[0]}–${range[1]} из ${total} тех. карт`,
        }}
      />

      <TechCardDetailModal
        record={detailRecord}
        onClose={() => setDetailRecord(null)}
      />
    </>
  );
}